import { z } from 'zod'

export const ResponseFormat = z.union([z.literal('raw'), z.literal('envelope')])
export type ResponseFormat = z.infer<typeof ResponseFormat>

// TODO: better name?
export const IncomingPayload = z.object({
  // TODO(imaman): in integration 'sqs', there is no return value  so acceptsFormat is ignored. Can we/should we express
  // it at the type level?
  acceptsFormat: ResponseFormat.default('raw'),
  endpointName: z.string(),
  endpointRequest: z.unknown(),
  headers: z.record(z.string(), z.string().optional()).optional(),
  searchParams: z.record(z.string(), z.string().optional()).optional(),
})

export type IncomingPayload = z.infer<typeof IncomingPayload>
